import React from 'react';
import { Col, Row, Divider } from 'antd';

export default function FluxoCaixaAnualGerencialSintetico({valoresProvisionados}) {

    return (
        <div>
            <div className="col-layout b-color-secondary text-center f-16">
                Local: <b className="f-16">Loja Matriz</b>
            </div>
            <Row gutter={[8,0]} className="f-14">
                <Col span={12} align="right">
                    <div>Caixa 1: <b className="c-primary">100,00</b></div>
                    <div>Caixa 2: <b className="c-primary">200,00</b></div>
                </Col>
                <Col span={12} align="left">
                    <div>Caixa 1: <b className="c-primary">100,00</b></div>
                    <div>Caixa 2: <b className="c-primary">200,00</b></div>
                </Col>
            </Row>
            <Divider className="m-0"/>
            <Row gutter={[8,0]} className="m-t-5 f-14">
                <Col span={12} align="right">
                    <div>SALDO INICIAL: <b className="c-primary">100,00</b></div>
                </Col>
                <Col span={12} align="left">
                    <div>SALDO FINAL: <b className="c-primary">100,00</b></div>
                </Col>
            </Row>

            {!valoresProvisionados &&
                <div className="tabela-fluxo m-t-19">
                    <Row className="b-color-secondary col-layout c-black t-head">
                        <Col align="center" span={10}><b>Fluxo de Caixa de <span className="f-14">2019</span> a <span className="f-14">2020</span></b></Col>
                        <Col span={14} align="right"><b>VALOR (R$)</b></Col>
                    </Row>
                    <div className="t-body p-0">
                        <Row className="row">
                            <Col align="left" span={24}>RECEITAS DIRETAS</Col>
                        </Row>
                        <Row className="row">
                            <Col align="left" className="p-l-25" span={10}>Clientes - Revenda de Mercadoria</Col>
                            <Col  span={14} align="right">0,00</Col>
                        </Row>
                        <Row className="c-primary row">
                            <Col align="left" span={10}><b>TOTAL DE RECEITAS</b></Col>
                            <Col  span={14} align="right"><b>26.477,56</b></Col>
                        </Row>
                        <Row className="row">
                            <Col align="left" span={24}>CUSTOS</Col>
                        </Row>
                        <Row className="row">
                            <Col align="left" className="p-l-25" span={10}>Compras de Mercadorias para Revenda</Col>
                            <Col  span={14} align="right">0,00</Col>
                        </Row>
                        <Row className="c-red row">
                            <Col align="left" span={10}><b>TOTAL DE DESPESAS</b></Col>
                            <Col  span={14} align="right"><b>26.477,56</b></Col>
                        </Row>
                        <Row className="row">
                            <Col align="left" span={10}><b>SALDO DO PERÍODO</b></Col>
                            <Col className="c-primary"  span={14} align="right"><b>26.477,56</b></Col>
                        </Row>  
                    </div>
                </div>
            }
            {valoresProvisionados &&
                <div className="tabela-fluxo m-t-19">
                    <Row className="b-color-secondary col-layout c-black t-head">
                        <Col align="center" span={10}><b>Fluxo de Caixa de <span className="f-14">2019</span> a <span className="f-14">2020</span></b></Col>
                        <Col span={7} align="right"><b>PREVISTO</b></Col>
                        <Col span={7} align="right"><b>REALIZADO</b></Col>
                    </Row>
                    <div className="t-body p-0">
                        <Row className="row">
                            <Col align="left" span={24}>RECEITAS DIRETAS</Col>
                        </Row>
                        <Row className="row">
                            <Col align="left" className="p-l-25" span={10}>Clientes - Revenda de Mercadoria</Col>
                            <Col span={7} align="right">0,00</Col>
                            <Col span={7} align="right">0,00</Col>
                        </Row>
                        <Row className="c-primary row">
                            <Col align="left" span={10}><b>TOTAL DE RECEITAS</b></Col>
                            <Col span={7} align="right"><b>26.477,56</b></Col>
                            <Col span={7} align="right"><b>26.477,56</b></Col>
                        </Row>
                        <Row className="row">
                            <Col align="left" span={24}>CUSTOS</Col>
                        </Row>
                        <Row className="row">
                            <Col align="left" className="p-l-25" span={10}>Compras de Mercadorias para Revenda</Col>
                            <Col span={7} align="right">0,00</Col>
                            <Col span={7} align="right">0,00</Col>
                        </Row>
                        <Row className="c-red row">
                            <Col align="left" span={10}><b>TOTAL DE DESPESAS</b></Col>
                            <Col span={7} align="right"><b>26.477,56</b></Col>
                            <Col span={7} align="right"><b>26.477,56</b></Col>
                        </Row>
                        <Row className="row">
                            <Col align="left" span={10}><b>SALDO DO PERÍODO</b></Col>
                            <Col className="c-primary" span={7} align="right"><b>26.477,56</b></Col>
                            <Col className="c-primary" span={7} align="right"><b>26.477,56</b></Col>
                        </Row>  
                    </div>
                </div>
            }
        </div>
    );
}